import React from "react";

const LoginNavbar = () => {
    return(
        <nav className="navbar navbar-expand-lg navbar-dark sticky-top bg-dark flex-nowrap p-2">
            <div className="container">
                <a className="navbar-brand col-sm-3 col-md-2 mx-auto p-4" href="/">
                    <img src="/assets/logo.png" alt="log"/>
                </a>
            </div>
        </nav>
    )
};
export default LoginNavbar;
